import PropTypes from 'prop-types';
import React, { useMemo, ReactNode, CSSProperties } from 'react';
import { isAuthenticated } from '../../services/AuthService';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import styles from './Container.scss';
import { useAlert } from 'contexts/alert/AlertContext';

const rootClassName = styles.rootClassName;

interface ContainerProps {
  title?: string;
  className?: string;
  noPadding?: boolean;
  style?: CSSProperties;
  children?: ReactNode;
}

export default function Container(props: ContainerProps) {
  const { showAlert } = useAlert();

  const classes = useMemo(
    () =>
      getMergedClassNames([
        rootClassName,
        'scroll-secondary',
        props.className ? props.className : '',
        props.noPadding ? `${rootClassName}-no-padding` : '',
        isAuthenticated() && showAlert === false
          ? `${rootClassName}-logged`
          : '',
        isAuthenticated() && showAlert === true ? 'alert-shown' : '',
      ]),
    [props.className, props.noPadding, showAlert]
  );

  const title = useMemo(
    () => (props.title ? <h2>{props.title}</h2> : null),
    [props.title]
  );

  return (
    <div className={classes} style={{ ...(props.style || {}) }}>
      {title}
      {props.children}
    </div>
  );
}

Container.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  noPadding: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.node,
};